export default "__VITE_ASSET__BsyZulkY__"